// Utility functions for formatting data in Trans Messages components

export const formatAmount = (amount) => {
    if (!amount) return '';
    return `KES ${new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(parseFloat(amount))}`;
};

export const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleString('sv-SE', { timeZone: 'Africa/Nairobi' }).replace('T', ' ');
};

export const getStatusColor = (status) => {
    const statusConfig = {
        pending: 'amber',
        posted: 'green',
        failed: 'red',
        used: 'gray'
    };
    return statusConfig[status] || 'gray';
};
